import { CONSERVATION_PROJECTS } from '@/api/rest/resources/conservation';
import { ProjectType } from '@/api/rest/resources/types/project';
import { useProjectDetailById } from '@/pages/shared/hooks/useProjectDetailById';

export const useConservationProjectName = (id?: string) => {
  const projectDetails = useProjectDetailById(id).data;

  if (projectDetails.type !== ProjectType.conservation) {
    throw new Error(`${projectDetails.id} is not a conservation project`);
  }
  const normalizedProjectName = projectDetails.name
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  return Object.values(CONSERVATION_PROJECTS).find((name) => {
    const hasLegalNumber = !!projectDetails.legal_number; // Some projects have multiple instances, we use the legal_number to differentiate them (e.g legal_number === v2)
    const nameToCheck = hasLegalNumber ? name.substring(0, name.length - 3) : name;

    const hasNameMatch = normalizedProjectName.includes(nameToCheck);

    if (!hasNameMatch) {
      return false;
    }

    if (!hasLegalNumber) {
      return true;
    }

    return name === `${nameToCheck}_${projectDetails.legal_number}`;
  });
};
